import * as React from "react";

function Alert({
  className,
  variant,
  ...props
}: React.ComponentProps<"div"> & { variant?: "default" | "destructive" }) {
  return (
    <div data-slot="alert" role="alert" className={`${className}`} {...props} />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={`col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        ${className}
      `}
      {...props}
    />
  );
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={`text-muted-foreground col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed"
        ${className}
      `}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription };
